import React, { useState } from 'react'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import { API, graphqlOperation } from 'aws-amplify'
import { useSelector } from 'react-redux'

const styles = {
    popUpText: {
        marginTop: '2em',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
    },
    popUpButtons: {
        marginTop: '3em',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    popUpCancel: {
        height: 40,
        width: 102,
        borderRadius: 10,
        fontSize: 16,
    },
    popUpActivate: {
        backgroundColor: '#1BAAF1',
        borderColor: '#1BAAF1',
        borderRadius: 10,
        width: 102,
        height: 40,
        fontSize: 16,
    },
    errorText: {
        color: 'red',
        textAlign: 'center',
    },
}

const updatePopulation = `mutation UpdatePopulation($pk: ID!, $sk: String, $input: tenantPopulationInput) {
    updateTenantPopulation(pk: $pk, sk: $sk, input: $input) {
        pk
        sk
        estimated 
        changedAt
        modifiedBy
    }
}`

const TenantEstimatedEmployees = ({ onUpdate }) => {
    const tenant = useSelector((state) => state.app.tenant)
    const user = useSelector(state => state.app.user)

    const [estimatedEmployees, setEstimatedEmployees] = useState('')
    const [errorMessage, setErrorMessage] = useState(null)

    const onInputChange = (e) => {
        setEstimatedEmployees(e.target.value)
    }

    const updateTenant = async () => {
        if (estimatedEmployees.length > 0) {
            let data = {
                pk: tenant.pk,
                sk: 'TENANT_POPULATION',
                d1: tenant.d1,
                estimated: estimatedEmployees,
                changedAt: Date.now(),
                modifiedBy: user.email
            }

            let response
            try {
                response = await API.graphql(
                    graphqlOperation(updatePopulation, {
                        pk: tenant.pk,
                        sk: 'TENANT_POPULATION',
                        input: data,
                    })
                )
            } catch (e) {
                response = e
            }
            onUpdate(response)
        } else {
            setErrorMessage('Please input your estimated number of employees')
        }
    }

    return (
        <div>
            <div style={styles.errorText}>{errorMessage}</div>
            <div style={styles.popUpText}>
                <span>
                    My company has
                    <Input
                        style={{ width: 50, marginLeft: 3,  marginRight: 3 }}
                        onChange={onInputChange}
                        value={estimatedEmployees}
                    />
                    estimated employees
                </span>
            </div>
            <div style={styles.popUpButtons}>
                <Button
                    style={styles.popUpActivate}
                    htmlType="button"
                    type="primary"
                    onClick={updateTenant}
                >
                    Save
                </Button>
            </div>
        </div>
    )
}

export default TenantEstimatedEmployees
